import React, { useState } from "react";
import { useParams, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import md5 from "md5";
// Redux
import { useSelector } from "react-redux";
// Constants
import { pathHomePage, WEB_SERVICE_DASHBOARD_ROUTE } from "../../../../../../config/constants";
import { passwordValidation, handleGenerateRandomPassword } from "../../../../../../config/functions";
// Components
import {
  Title,
  ClinicianInfoDiv,
  DataDiv,
  ColumnDataDiv,
  InputDataDiv,
  Label,
  Input,
  Select,
  RelativeButton,
  GeneratePasswordButton,
  SubmitButton,
  SubmitButtonDiv,
} from "./styles";
import GoBack from "../../../../../goBack";
import Header from "../../../../../header";
import Axios from "../../../../../../config/axios";
// Assets
import VisiblePasswordImg from "../../../../../../assets/btn_visible_password.svg";
import HidePasswordImg from "../../../../../../assets/btn_hide_password.svg";
import GeneratePasswordImg from "../../../../../../assets/generate_password.png";

const CreateClinician = () => {
  const [user, setUser] = useState("");
  const [userError, setUserError] = useState(false);
  const [password, setPassword] = useState("");
  const [visiblePassword, setVisiblePassword] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [role, setRole] = useState("");
  const [roleError, setRoleError] = useState(false);
  const [firstLoginToMims, setFirstLoginToMims] = useState("");
  const [firstLoginToMimsError, setFirstLoginToMimsError] = useState(false);
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState(false);
  const [surname1, setSurname1] = useState("");
  const [surname1Error, setSurname1Error] = useState(false);
  const [surname2, setSurname2] = useState("");
  const [surname2Error, setSurname2Error] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState(false);

  const [redirectToCliniciansManagement, setRedirectToCliniciansManagement] = useState(false);
  const { hospitalId } = useParams();
  const environment = useSelector(({ database }) => database.environment);

  const handleCreateClinician = (e) => {
    e.preventDefault();
    if (user === "") {
      setUserError(true);
      return toast.error("You must enter an user");
    }
    if (!passwordValidation(password)) {
      setPasswordError(true);
      return toast.error(
        "The password must contain at least: 8 characters, one uppercase letter, one lowercase letter, one digit, one special character"
      );
    }
    if (role === "") {
      setRoleError(true);
      return toast.error("You must select a user role");
    }
    if (firstLoginToMims === "") {
      setFirstLoginToMimsError(true);
      return toast.error("You must select the password change option");
    }
    const clinicianData = {
      HOSPITAL_ID: hospitalId,
      CLINICIAN_USER: user,
      PASSWORD: md5(`${user}${password}`),
      ROLE: role,
      NAME: name === "" ? null : name,
      SURNAME1: surname1 === "" ? null : surname1,
      SURNAME2: surname2 === "" ? null : surname2,
      EMAIL: email === "" ? null : email,
      PHONE: phone === "" ? null : phone,
      FIRST_LOGIN_TO_MIMS: firstLoginToMims,
    };
    Axios("post", `${WEB_SERVICE_DASHBOARD_ROUTE}/clinician/add/${environment}`, clinicianData)
      .then(({ data }) => {
        if (data.addedClinician) {
          toast.success("Professional created successfully");
          setRedirectToCliniciansManagement(true);
        }
      })
      .catch((error) => {
        if (error.response.data.duplicatedClinician) {
          toast.error("The entered user already exists");
        } else {
          toast.error("Error sending data, try again");
        }
        console.log("Add clinician: ", error);
      });
  };
  if (redirectToCliniciansManagement) {
    return <Redirect to={`${pathHomePage}/clinicians-by-hospital/${hospitalId}`} />;
  }

  const renderAddClinicianForm = () => {
    const handleSetPasswordVisibility = (e) => {
      e.preventDefault();
      setVisiblePassword(!visiblePassword);
    };

    const handleSetGenerateRandomPassword = (e) => {
      e.preventDefault();
      setPassword(handleGenerateRandomPassword());
    };

    const onChangeInput = (e, setValue, setValueError) => {
      setValue(e.target.value);
      setValueError(false);
    };

    return (
      <ClinicianInfoDiv>
        <DataDiv>
          <ColumnDataDiv>
            <InputDataDiv>
              <Label htmlFor="clinicianUser" fontWeight="bold">
                Username *
              </Label>
              <Input
                type="text"
                id="clinicianUser"
                value={user}
                onChange={(e) => onChangeInput(e, setUser, setUserError)}
                error={userError}
              />
            </InputDataDiv>
            <InputDataDiv>
              <Label htmlFor="password" fontWeight="bold">
                Password *
              </Label>
              <Input
                type={visiblePassword ? "text" : "password"}
                placeholder="*******"
                id="password"
                value={password}
                onChange={(e) => onChangeInput(e, setPassword, setPasswordError)}
                error={passwordError}
              />
              <RelativeButton onClick={handleSetPasswordVisibility}>
                <img src={visiblePassword ? HidePasswordImg : VisiblePasswordImg} alt="icon-password" />
              </RelativeButton>
              <GeneratePasswordButton onClick={handleSetGenerateRandomPassword}>
                <img src={GeneratePasswordImg} alt="icon-generate-password" />
              </GeneratePasswordButton>
            </InputDataDiv>
            <InputDataDiv>
              <Label htmlFor="name" fontWeight="bold">
                Name
              </Label>
              <Input type="text" id="name" value={name} onChange={(e) => onChangeInput(e, setName, setNameError)} error={nameError} />
            </InputDataDiv>
            <InputDataDiv>
              <Label htmlFor="surname1" fontWeight="bold">
                First surname
              </Label>
              <Input
                type="text"
                id="surname1"
                value={surname1}
                onChange={(e) => onChangeInput(e, setSurname1, setSurname1Error)}
                error={surname1Error}
              />
            </InputDataDiv>
            <InputDataDiv>
              <Label htmlFor="surname2" fontWeight="bold">
                Second surname
              </Label>
              <Input
                type="text"
                id="surname2"
                value={surname2}
                onChange={(e) => onChangeInput(e, setSurname2, setSurname2Error)}
                error={surname2Error}
              />
            </InputDataDiv>
          </ColumnDataDiv>
          <ColumnDataDiv>
            <InputDataDiv>
              <Label htmlFor="role" fontWeight="bold">
                Role *
              </Label>
              <Select value={role} onChange={(e) => onChangeInput(e, setRole, setRoleError)} error={roleError}>
                <option value={""}></option>
                <option value={"THERAPIST"}>THERAPIST</option>
                <option value={"ADMIN"}>ADMIN</option>
              </Select>
            </InputDataDiv>
            <InputDataDiv>
              <Label htmlFor="role" fontWeight="bold">
                Password change *
              </Label>
              <Select
                value={firstLoginToMims}
                onChange={(e) => onChangeInput(e, setFirstLoginToMims, setFirstLoginToMimsError)}
                error={firstLoginToMimsError}
              >
                <option value={""}></option>
                <option value={0}>No</option>
                <option value={1}>Sí</option>
              </Select>
            </InputDataDiv>
            <InputDataDiv>
              <Label htmlFor="phone" fontWeight="bold">
                Phone number
              </Label>
              <Input type="text" id="phone" value={phone} onChange={(e) => onChangeInput(e, setPhone, setPhoneError)} error={phoneError} />
            </InputDataDiv>
            <InputDataDiv>
              <Label htmlFor="email" fontWeight="bold">
                Email
              </Label>
              <Input type="text" id="email" value={email} onChange={(e) => onChangeInput(e, setEmail, setEmailError)} error={emailError} />
            </InputDataDiv>
          </ColumnDataDiv>
        </DataDiv>
        <SubmitButtonDiv>
          <SubmitButton onClick={handleCreateClinician}>Save</SubmitButton>
        </SubmitButtonDiv>
      </ClinicianInfoDiv>
    );
  };

  return (
    <>
      <Header />
      <GoBack path={`${pathHomePage}/clinicians-by-hospital/${hospitalId}`} />
      <Title>Create new clinician</Title>
      {renderAddClinicianForm()}
    </>
  );
};

export default CreateClinician;
